import { FC } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { State } from 'redux/initialState';
import { useTranslate } from 'hooks/useTranslate';

import { User } from 'types';

import menuTypes from 'constants/menuTypes';
import isSuperAdmin from 'utils/isSuperAdmin';

type Props = {
  type: string;
  societyName: string;
  societyId: string;
  user: User;
};

const SideNavTitle: FC<Props> = ({ type, societyName, societyId, user }) => {
  const { t } = useTranslate();

  const isSocietyDemo = useSelector(
    (state: State) => state.society?.actualSociety?.isSocietyDemo
  );
  const hasAccessCaptable = useSelector(
    (state: State) => state.society?.actualSociety?.hasAccessCaptable
  );
  const hasWhiteBranding = useSelector(
    (state: State) =>
      state.society?.actualSociety?.configuration?.hasWhiteBranding
  );
  const { isAdmin, isPartner } = useSelector(
    (state: State) =>
      state?.society?.role || {
        isAdmin: false,
        isPartner: false,
        isBeneficiary: false,
      }
  );

  if (type === menuTypes.MAIN && !hasWhiteBranding) {
    return <>{t('Societies')}</>;
  }

  if (
    type !== menuTypes.MAIN &&
    !isAdmin &&
    (!isPartner || !hasAccessCaptable)
  ) {
    return <>{societyName}</>;
  }

  if (type !== menuTypes.MAIN) {
    return (
      <Link to={`/sociedad/${societyId}`} className="text-primary">
        {societyName}
        {isSuperAdmin(user) && isSocietyDemo && (
          <small className="badge badge-pill badge-primary ml-1">DEMO</small>
        )}
      </Link>
    );
  }

  return null;
};

export default SideNavTitle;
